import { Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import { DailyPage } from './pages/DailyPage'
import { CreatePage } from './pages/CreatePage'
import { PlayPage } from './pages/PlayPage'
import { HomePage } from './pages/HomePage'
import { HelpPage } from './pages/HelpPage'
import { AccountPage } from './pages/AccountPage'
import { StatusBar, Style } from '@capacitor/status-bar'
import { Capacitor } from '@capacitor/core'
import { initGameServices } from './lib/achievements'

/**
 * 应用主组件
 * 定义路由结构
 */
function App() {
  // 配置原生状态栏
  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      const configStatusBar = async () => {
        try {
          await StatusBar.setStyle({ style: Style.Dark })
          await StatusBar.setBackgroundColor({ color: '#09090B' }) // zinc-950
        } catch (e) {
          console.warn('Status bar config failed', e)
        }
      }
      configStatusBar()
    }
  }, [])

  // 成就系统：应用启动时尝试静默登录 Game Center（iOS）/ Play Games（Android）
  // 仅在原生平台上执行，Web/PWA 环境自动跳过
  useEffect(() => {
    initGameServices()
  }, [])

  return (
    <div className="min-h-screen">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/daily" element={<DailyPage />} />
        <Route path="/create" element={<CreatePage />} />
        <Route path="/play/:id" element={<PlayPage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/account" element={<AccountPage />} />
      </Routes>
    </div>
  )
}

export default App

